<template>
  <div>
    <PublicShell :igreja="igreja" titulo="Escola Ministerial" :valido="!!igrejaId" max-width="720px">
      <p class="pub-intro">Selecione a turma:</p>
      <v-container fluid grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex xs12 sm12 lg12>
            <v-select outlined dense v-model="inscricao.eventoId" :items="eventos" item-text="nome" item-value="id" color="#00695C" no-data-text="Nenhuma turma disponível" @input="pegaEventoSelecionado"></v-select>
          </v-flex>
          <v-flex xs12 sm12 lg12 v-if="eventoSelecionado.detalhes">
            <v-alert type="warning" icon="info">{{ eventoSelecionado.detalhes }}</v-alert>
          </v-flex>
          <v-flex xs12 sm12 lg12>
            <p class="pub-intro mt-2">Dados do membro:</p>
          </v-flex>
          <v-flex xs12 sm12 lg12>
            <v-text-field light label="CPF*" color="#00695C" outlined v-mask="'###.###.###-##'" dense hide-details type="tel" v-model="membro.cpf" @change="consultaCPF(membro.cpf)" append-outer-icon="search"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg8>
            <v-text-field light disabled v-model="membro.nome" label="NOME" outlined color="#00695C" dense hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg4>
            <v-text-field light disabled v-model="membro.celula" label="CÉLULA" outlined color="#00695C" dense hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg12>
            <p class="pub-intro mt-2">Dados da inscrição:</p>
          </v-flex>
          <v-flex xs12 sm12 lg4>
            <v-select outlined dense :disabled="!membro.nome" v-model="inscricao.sexo" :items="sexos" hide-details color="#00695C" label="SEXO"></v-select>
          </v-flex>
          <v-flex xs12 sm12 lg4>
            <v-text-field light :disabled="!membro.nome" v-model="inscricao.whatsApp" label="WHATSAPP" outlined color="#00695C" dense hide-details></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>

      <v-btn dark depressed block color="#00695C" rounded large class="mt-5" @click="salvaInscricao">Confirmar Cadastro</v-btn>
    </PublicShell>

    <v-dialog v-model="dialogoCadastroConcluido" persistent max-width="500px">
          <v-card>
            <v-card-text style="padding-bottom: 0px">
              <v-container>
                <v-row dense>
                  <v-col cols="12" style="text-align: center; padding: 2px;">
                    <v-icon left color="success" size="100">check_circle</v-icon>
                    <p class="em-texto" style="color:#00695C">Inscrição realizada com sucesso!</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="closeDialog">Concluir</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoNaoCadastrado" persistent max-width="500px">
          <v-card>
            <v-card-title>Atenção</v-card-title>
            <v-card-text style="padding-bottom: 0px">
              <v-container>
                <v-row dense>
                  <v-col cols="12" style="text-align: center; padding: 2px;">
                    <v-icon left color="warning" size="100">warning</v-icon>
                    <p class="em-texto" style="color: #666">O CPF informado não possui cadastro na <strong>{{ igreja.nome }}</strong>. <a :href="`/cadastro-membro?igrejaId=${igrejaId}`">Clique aqui</a> e cadastre-se primeiro.<br><br>Depois, tente novamente.</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dialogoNaoCadastrado = false">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref="chamaSnackbar" />
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { baseApiUrl } from '@/global'
import Snackbar from '../../componentes/snackbar.vue'
import moment from 'moment'
import axios from 'axios'
import PublicShell from '../../componentes/PublicShell.vue'

export default {
  name: 'EscolaMinisterialPublico',
  components: { Snackbar, Loading, PublicShell },
  data() {
    return {
      igrejaId: '',
      igreja: {},
      membro: { nome: '', celula: '', cpf: '', id: '' },
      inscricao: { nome: '', cpf: '', sexo: '', eventoId: '', membroId: '', igrejaId: '', whatsApp: '' },
      sexos: ['MASCULINO', 'FEMININO'],
      dialogoNaoCadastrado: false,
      dialogoCadastroConcluido: false,
      isLoading: false,
      fullPage: true,
      celulas: [],
      eventos: [],
      eventoSelecionado: [],
    }
  },
  mounted() {
    this.igrejaId = this.$route.query.igrejaId || ''
    if (this.igrejaId) {
      this.carregaDados()
      this.carregaCelulas()
      this.carregaEventos()
    }
  },
  watch: {
    dialogoNaoCadastrado(val) { if (val === false) window.location.reload() },
  },
  methods: {
    async carregaDados() {
      this.isLoading = true
      try {
        const response = await axios.post(baseApiUrl + 'Igrejas/infoPublica', null, { params: { igrejaId: this.igrejaId } })
        if (response.data) {
          this.igreja = response.data
          this.inscricao.igrejaId = response.data.id
        }
      } catch (error) {
        this.igrejaId = ''
      } finally {
        this.isLoading = false
      }
    },
    async carregaEventos() {
      await axios.post(baseApiUrl + 'eventos/listarPublicosEM', null, { params: { igrejaId: this.igrejaId } })
        .then(response => {
          if (response.data) {
            for (let i = 0; i < response.data.length; i++) {
              if (moment(this.formatDateHora(response.data[i].fim), 'DD/MM/YYYY HH:mm:ss', true).format() >= moment().format()) {
                this.eventos.push(response.data[i])
              }
            }
          }
        })
    },
    async carregaCelulas() {
      await axios.post(baseApiUrl + 'Celulas/listarPublicas', null, { params: { igrejaId: this.igrejaId } })
        .then(response => { if (response.data) this.celulas = response.data })
    },
    async consultaCPF(cpf) {
      this.isLoading = true
      await axios.post(baseApiUrl + 'Membros/buscaPublicaCpf', null, { params: { cpf: cpf, igrejaId: this.igrejaId } })
        .then(response => {
          if (response.data && response.data.id) {
            this.membro.nome = response.data.nome
            this.inscricao.nome = response.data.nome
            this.membro.celula = response.data.celula && response.data.celula.nome
              ? response.data.celula.nome
              : this.nomeCelula(response.data.celulaId)
            this.inscricao.cpf = response.data.cpf
            this.inscricao.membroId = response.data.id
            this.inscricao.whatsApp = response.data.telefone
            this.inscricao.sexo = response.data.sexo
          } else {
            this.dialogoNaoCadastrado = true
          }
          this.isLoading = false
        })
    },
    formatDateHora(date) {
      if (!date) return null
      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}` + ' ' + date.substr(11, 8)
    },
    closeDialog() { window.location.reload() },
    async salvaInscricao() {
      const vm = this
      if (!this.inscricao.nome || !this.inscricao.sexo || !this.inscricao.eventoId || !this.inscricao.membroId || !this.inscricao.whatsApp) {
        vm.$refs.chamaSnackbar.snack('#F9A825', 'Preencha todos os campos para continuar!', 'ATENÇÃO')
      } else {
        this.isLoading = true
        if (await this.verificaInscricaoCpf(this.inscricao.cpf)) {
          vm.$refs.chamaSnackbar.snack('#F9A825', 'Já existe uma inscrição do membro informado para esta turma', 'ATENÇÃO')
          this.isLoading = false
        } else {
          await axios.post(baseApiUrl + 'inscricoes/salvarPublica', this.inscricao)
            .then(response => {
              if (response.data) {
                this.dialogoCadastroConcluido = true
                this.isLoading = false
              }
            })
        }
      }
    },
    nomeCelula(celulaId) {
      let nome
      this.celulas.filter(celula => { if (celula.id === celulaId) nome = celula.nome.trim() })
      return nome
    },
    async verificaInscricaoCpf(cpf) {
      let existe
      await axios.post(baseApiUrl + 'inscricoes/verificaExistencia', null, { params: { cpf: cpf, eventoId: this.inscricao.eventoId } })
        .then(response => {
          existe = !(!response.data || response.data.existe === false || response.data.count == 0)
        })
      return existe
    },
    pegaEventoSelecionado() {
      for (let i = 0; i < this.eventos.length; i++) {
        if (this.eventos[i].id == this.inscricao.eventoId) this.eventoSelecionado = this.eventos[i]
      }
    },
  },
}
</script>

<style scoped>
.pub-intro { color: #5b6b67; margin: 0 0 6px; font-size: .95rem; }
.em-texto { font-weight: bold; color: #00253E; font-size: 17px; }
</style>
